import { render, staticRenderFns } from "./CampaignContacts.vue?vue&type=template&id=5cfc6f58&scoped=true&"
import script from "./CampaignContacts.vue?vue&type=script&lang=js&"
export * from "./CampaignContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfc6f58",
  null
  
)

export default component.exports